import type { Generated, Selectable } from 'kysely'
import z from 'zod'

import { HTTP_METHODS } from '@scalar/helpers/http/http-methods'

export type OperationEntity = {
  id: Generated<string>
  path: string
  method: string
  versionId: string
  embedding: number[]
  searchToolEnabled: boolean
  executeRequestToolEnabled: boolean
}

export type Operation = Selectable<OperationEntity>

export const methodSchema = z.enum(HTTP_METHODS).meta({ id: 'method' })

export const operationSchema = z
  .object({
    id: z.uuid(),
    path: z.string(),
    method: methodSchema,
    versionId: z.uuid(),
    embedding: z.number().array(),
    searchToolEnabled: z.boolean(),
    executeRequestToolEnabled: z.boolean(),
  })
  .meta({ id: 'operation' }) satisfies z.ZodType<Operation>
